export const DATE_FORMAT = Object.freeze({
  FULL: "MMMM DD, YYYY HH:mm:ss",
  SHORT: "MMM D, YYYY HH:mm",
  SHORT_DATE: "MMM D, YYYY",
});

export default {};
